import css1 from '../img/portImages/cv_css.png';
import p1 from '../img/portImages/1.png';
import p2 from '../img/portImages/2.png';
import p3 from '../img/portImages/3.png';
import p4 from '../img/portImages/4.png';
import p5 from '../img/portImages/5.png';
import p6 from '../img/portImages/6.png';
import p7 from '../img/portImages/7.png';
import scavengers from '../img/portImages/12.png'
import lybrate from '../img/portImages/lybrate.png'

const portfolios = [
    {
        id: 1,
  // category: 'Web Application',
        image: scavengers,
        link1: 'https://github.com/girishv694/E-wasteManagement',
        link2: 'https://e-waste-management.netlify.app/',
        title: 'Scavenger',
        text: 'It is an e-waste management app made for mobile screens',
        text2:'Stack used : HTML| CSS | React | MongoDb | Express'
    },
    {
        id: 2,
       // category: 'Web Application',
        image: lybrate,
        link1: 'https://github.com/abhishek-hero/lybrate_Clone',
        link2: 'https://lybrateclone01.herokuapp.com/',
        title: 'Lybrate',
        text: 'It is an online doctor appointment booking app',
        text2:'Stack used : HTML| CSS | JavaScript'
    },
//     {
//         id: 3,
//        // category: 'Booking Platform',
//         image: css1,
//         link1: 'https://github.com/singhabhishek6/Agoda-Clone',
//         link2: 'https://agoda.netlify.app/',
//         title: 'Agoda Clone',
//         text: ''
//     },
//     {
//         id: 4,
//        // category: 'Web Application',
//         image: p1,
//         link1: 'https://github.com/singhabhishek6/IndeedClone-1',
//         link2: 'https://indeed-clone.netlify.app',
//         title: 'Indeed Clone',
//         text: ''
//     },
//     {
//         id: 5,
//        // category: 'Ecommerce',
//         image: p2,
//         link1: 'https://github.com/singhabhishek6/TataCLiQ-Clone',
//         link2: 'https://tatacliq.netlify.app/',
//         title: 'TataCliq Clone',
//         text: ''
//     },

//     {
//         id: 6,
//        // category: 'Web Application',
//         image: p3,
//         link1: 'https://github.com/singhabhishek6/singhabhishek6.github.io',
//         link2: 'https://singhabhishek6.github.io/',
//         title: 'Bloger Website Demo',
//         text: ''
//     },
//     {
//         id: 7,
//        // category: 'Game',
//         image: p4,
//         link1: 'https://github.com/singhabhishek6/poject',
//         link2: 'https://singhabhishek6.github.io/poject/',
//         title: 'RGB Guessing Game',
//         text: ''
//     },
    // {
    //     id: 8,
    //    // category: 'Game',
    //     image:p5,
    //     link1: 'https://github.com/singhabhishek6/hexagon',
    //     link2: 'https://hexagon-effect.netlify.app/',
    //     title: 'Neon Hexagones',
    //     text: ''
    // }
]

export default portfolios;
